import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import Constants from "../../utils/constants";
import {laveusesActions} from "../../modules/laveuses/laveuses.actions";
import {LocalShipping} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import Grid from "@mui/material/Grid2";
import LaveuseMap from "./laveuse/LaveuseMap.js";
import LaveuseListPanel from "./laveuse/LaveuseListPanel.js";
import LaveuseDetailPanel from "./laveuse/LaveuseDetailPanel.js";
import {useNavigate} from "react-router-dom";
import {Stack} from "@mui/material";
import Button from "@mui/material/Button";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import MapIcon from "@mui/icons-material/Map";

const getMode = (type) => {
    const mode = window.localStorage.getItem(`laveuse_tracking_view_${type}`);
    return mode === null ? true : mode === "true";
};

const isMobileOrTablet = () => {
    return /Mobi|Android|iPad|iPhone/i.test(navigator.userAgent)
        || window.matchMedia("(pointer: coarse)").matches;
};


const sortedLaveuses = (laveuses) => {
    if (!laveuses) return laveuses;
    return [...laveuses].sort((a, b) => {
        const lvRegex = /^LV(\d+)$/i;
        const matchA = (a.description || '').match(lvRegex);
        const matchB = (b.description || '').match(lvRegex);
        if (matchA && !matchB) return -1;
        if (!matchA && matchB) return 1;
        if (matchA && matchB) return parseInt(matchA[1], 10) - parseInt(matchB[1], 10);
        return (a.description || '').localeCompare(b.description || '', undefined, {numeric: true, sensitivity: 'base'});
    });
};

function LaveuseTrackingPage({dispatch, ...props}) {
    const [selectedLaveuse, setSelectedLaveuse] = useState(null);
    const [flyKey, setFlyKey] = useState(0);
    const [showRoute, setShowRoute] = useState(false);
    const [showTournee, setShowTournee] = useState(false);
    const [tourneeFitKey, setTourneeFitKey] = useState(0);
    const [routeFitKey, setRouteFitKey] = useState(0);
    const navigate = useNavigate();
    const [listModeEnabled, setListModeEnabled] = useState(getMode(Constants.MODE_LIST));
    const [mapModeEnabled, setMapModeEnabled] = useState(getMode(Constants.MODE_MAP));

    const [isMobile, setIsMobile] = useState(isMobileOrTablet());

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(isMobileOrTablet());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!props.laveuses && !props.loading && !props.error) {
            dispatch(laveusesActions.fetchLaveuses())
        }
    }, [props.laveuses, props.loading, props.error]);

    useEffect(() => {
        if (props.laveuses) {
            dispatch(laveusesActions.fetchTelematicsBulk());
        }
    }, [props.laveuses, dispatch]);

    // Rafraîchissement périodique des télémétries (TTL 30s côté serveur)
    useEffect(() => {
        if (!props.laveuses) return;
        const interval = setInterval(() => {
            dispatch(laveusesActions.fetchTelematicsBulk());
        }, 30000);
        return () => clearInterval(interval);
    }, [props.laveuses, dispatch]);

    useEffect(() => {
        return () => {
            // dispatch(conteneursActions.clearLaveuses());
        };
    }, [dispatch]);

    const onLaveuseSelected = (lav) => {
        if (lav) {
            if (selectedLaveuse?.id === lav.id) {
                setSelectedLaveuse(null);
                setShowRoute(false);
                setShowTournee(false);
            } else {
                setSelectedLaveuse(lav);
                setShowRoute(false);
                setShowTournee(false);
                setFlyKey(k => k + 1);
                const today = new Date().toISOString().split('T')[0];
                dispatch(laveusesActions.fetchDailyContext(lav.id, today));
            }
        }
    }

    const handleToggleRoute = (val) => {
        setShowRoute(val);
        if (val) setRouteFitKey(k => k + 1);
    }

    const handleToggleTournee = (val) => {
        setShowTournee(val);
        if (val) setTourneeFitKey(k => k + 1);
    }

    const handleCloseDetail = () => {
        setSelectedLaveuse(null);
        setShowRoute(false);
        setShowTournee(false);
    }

    const handleShowTrips = (lav) => {
        navigate(Constants.APP_ROUTE_LAVEUSES_TRIPS_PAGE.replace(":id", lav?.id))
    }

    const toogleView = (type) => {
        if (type === Constants.MODE_LIST) {
            if (listModeEnabled && !mapModeEnabled && isMobile) return;
            const newVal = !listModeEnabled;
            setListModeEnabled(newVal);
            window.localStorage.setItem(`laveuse_tracking_view_${type}`, newVal);
        } else if (type === Constants.MODE_MAP) {
            if (mapModeEnabled && !listModeEnabled && isMobile) return;
            const newVal = !mapModeEnabled;
            setMapModeEnabled(newVal);
            window.localStorage.setItem(`laveuse_tracking_view_${type}`, newVal);
        }
    };

    const getListPanelSize = () => {
        if (!isMobile) return 3;
        if (listModeEnabled && mapModeEnabled) return 4;
        if (listModeEnabled) return 12;
        return 0;
    }

    const getMapPanelSize = () => {
        if (!isMobile) return 9;
        if (listModeEnabled && mapModeEnabled) return 7;
        if (mapModeEnabled) return 12;
        return 0;
    }

    return (
        <>
            {props.loading &&
                <Loader/>
            }
            {!props.loading &&
                <>
                    <Grid container>
                        {isMobile &&
                            <Grid size={12}>
                                <Stack spacing={2} direction="row" justifyContent="center" sx={{marginBottom: 2}}>
                                    <Button
                                        variant={listModeEnabled ? "contained" : "outlined"}
                                        color="primary"
                                        startIcon={<FormatListNumberedIcon/>}
                                        onClick={() => toogleView(Constants.MODE_LIST)}
                                    >
                                        Affichage liste
                                    </Button>

                                    <Button
                                        variant={mapModeEnabled ? "contained" : "outlined"}
                                        color="primary"
                                        startIcon={<MapIcon/>}
                                        onClick={() => toogleView(Constants.MODE_MAP)}
                                    >
                                        Affichage carte
                                    </Button>
                                </Stack>
                            </Grid>
                        }

                        {getListPanelSize() > 0 && (
                            <Grid size={getListPanelSize()}>
                                <LaveuseListPanel
                                    laveuses={sortedLaveuses(props.laveuses)}
                                    telematics={props.telematics}
                                    onSelect={onLaveuseSelected}
                                    selectedId={selectedLaveuse?.id}
                                />
                            </Grid>
                        )}

                        {getMapPanelSize() > 0 && (
                            <Grid size={getMapPanelSize()} key={`${getMapPanelSize()}`}>
                                <LaveuseMap
                                    laveuses={sortedLaveuses(props.laveuses)}
                                    telematics={props.telematics}
                                    selectedLaveuse={selectedLaveuse}
                                    onSelect={onLaveuseSelected}
                                    showRoute={showRoute}
                                    routeFitKey={routeFitKey}
                                    showTournee={showTournee}
                                    tourneeFitKey={tourneeFitKey}
                                    flyKey={flyKey}
                                    context={props.context}
                                >
                                    {selectedLaveuse && (
                                        <LaveuseDetailPanel
                                            laveuse={selectedLaveuse}
                                            telematics={props.telematics}
                                            onClose={handleCloseDetail}
                                            onShowTrips={handleShowTrips}
                                            showRoute={showRoute}
                                            onToggleRoute={handleToggleRoute}
                                            context={props.context}
                                            showTournee={showTournee}
                                            onToggleTournee={handleToggleTournee}
                                        />
                                    )}
                                </LaveuseMap>
                            </Grid>
                        )}

                    </Grid>
                </>
            }
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        laveuses: state.laveuses.laveuses,
        telematics: state.laveuses.telematics,
        context: state.laveuses.context,
        loading: state.laveuses.loading,
        error: state.laveuses.error
    }
}

export default connect(mapStateToProps)(LaveuseTrackingPage);
